/**
 * Estorno que é PASSO do fluxo guiado de cancelamento (TMS-7223 — janela do passo próprio).
 *
 * O estorno deixa a carga em `status_processo_expedicao = 2` e o operador só clica em
 * "Cancelar" minutos depois; nesse intervalo o agendador podia re-conduzir a carga pelo
 * pipeline de expedição. Quando o estorno é passo do fluxo guiado, o front manda
 * `para_cancelamento` e o backend protege a carga do agendador até o cancelamento.
 *
 * **Só o fluxo guiado manda o parâmetro.** O botão "Estornar cálculo" da linha (recalcular e
 * expedir de novo) usa o `form` compartilhado da view e segue sem ele — por isso o estorno
 * guiado tem um `Form` PRÓPRIO: o `Form` envia todos os campos declarados e guarda o que
 * lhe foi atribuído, então marcar o parâmetro no `form` compartilhado o faria vazar para
 * qualquer outro chamador.
 *
 * Módulo puro, para ser testado sem `vue-jest` nem o `Form` (que importa o app inteiro).
 * Sem `?.` nem `??`: o toolchain do isend-frontend não os compila.
 */

/** Campos do `Form` dedicado: a carga e o parâmetro, e nada mais. Objeto novo a cada chamada. */
export function camposEstornoParaCancelamento() {
  return { carga_id: "", para_cancelamento: true };
}

/**
 * Prepara o `Form` dedicado para o envio. O parâmetro é **reafirmado** a cada envio: o
 * `Form.reset()` zera todo campo declarado para `''`, e sem isso um reset perderia a
 * proteção em silêncio (o backend leria `''` como falso).
 *
 * @returns o próprio form, para encadear no `post`
 */
export function prepararFormEstornoParaCancelamento(form, cargaId) {
  form.carga_id = cargaId;
  form.para_cancelamento = true;

  return form;
}
